import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { PlatformCountriesProps } from "../types";
import { FormattedMessage } from "react-intl";

const PlatformCountries: React.FC<PlatformCountriesProps> = ({ releases }) => {
    const [countries, setCountries] = useState<any[]>([]);
    const [platforms, setPlatforms] = useState<any[]>([]);

    useEffect(() => {
        const release = releases.releases.data;
        setPlatforms(release?.platforms || []);
        setCountries(release?.countries || [])
    }, [releases]);


    return (
        <Wrapper>
            <InfoGrid>
                <InfoBlockTitle>
                    <FormattedMessage
                        id="NewRelease.Platform.Platforms"
                        defaultMessage="Platforms"
                    />
                </InfoBlockTitle>
                <InfoBlockContent>
                    <InfoBlock>
                        <InfoBlockText>
                            <FormattedMessage
                                id="NewRelease.Platform.Platforms"
                                defaultMessage="Platforms"
                            />
                        </InfoBlockText>
                        <Text>

                            <Text>
                                {platforms && platforms
                                    .filter(p => !p.ugc)
                                    .map(p => p.name)
                                    .join(', ')}

                            </Text>
                        </Text>
                    </InfoBlock>
                </InfoBlockContent>
            </InfoGrid>
            <Section>
                <InfoGrid>
                    <InfoBlockTitle>
                        <FormattedMessage
                            id="NewRelease.Platform.UGCPlatforms"
                            defaultMessage="UGC platforms"
                        />
                    </InfoBlockTitle>
                    <InfoBlockContent>
                        <InfoBlock>
                            <InfoBlockText>
                                <FormattedMessage
                                    id="NewRelease.Platform.UGCPlatforms"
                                    defaultMessage="UGC platforms"
                                />
                            </InfoBlockText>
                            <Text>
                                {/* <FormattedMessage
                                  id="NewRelease.Platform.UGCPlatformsText"
                                  defaultMessage="Youtube Content ID, TikTok Fingerprinting, Soundcloud, Facebook/Instagram"
                                /> */}
                                {platforms
                                    .filter(platform => platform.ugc)
                                    .map(platform => platform.name)
                                    .join(', ')}
                            </Text>
                        </InfoBlock>
                    </InfoBlockContent>
                </InfoGrid>
            </Section>
            <Section>
                <InfoGrid>
                    <InfoBlockTitle>
                        <FormattedMessage
                            id="NewRelease.Platform.Countries"
                            defaultMessage="Countries"
                        />
                    </InfoBlockTitle>
                    <InfoBlockContent>
                        {/* <InfoBlock>
                            <InfoBlockText>
                                <FormattedMessage
                                    id="NewRelease.Platform.TerritoryGroups"
                                    defaultMessage="Territory Groups"
                                />
                            </InfoBlockText>
                            <Text>
                                <FormattedMessage
                                    id="NewRelease.Platform.Neverland"
                                    defaultMessage="Neverland"
                                />
                            </Text>
                        </InfoBlock> */}
                        <InfoBlock>
                            <InfoBlockText>
                                <FormattedMessage
                                    id="NewRelease.Platform.Countries"
                                    defaultMessage="Countries"
                                />
                            </InfoBlockText>
                            <Text>
                                {countries?.length ? (
                                  <FormattedMessage
                                      id="NewRelease.Platform.AllCountries"
                                      defaultMessage="The Whole World"
                                  />
                                ) : (
                                  <FormattedMessage
                                      id="NewRelease.Platform.TheWholeWorld"
                                      defaultMessage="The Whole World"
                                  />
                                )}
                            </Text>
                            {!!countries?.length && (
                              <CountriesTooltipBox>
                                {countries.map((c: any) => c?.name ?? c).filter(Boolean).join(", ")}
                              </CountriesTooltipBox>
                            )}
                        </InfoBlock>
                    </InfoBlockContent>
                </InfoGrid>
            </Section>
        </Wrapper>
    );
};

const Wrapper = styled.section`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 30px;
    font-family: Arial, sans-serif;
`;

const InfoBlockTitle = styled.span`
    font-family: SF Pro Display;
    font-weight: 700;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0;
`

const InfoBlockText = styled.div`
    font-family: SF Pro Display;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0;
    color: #00000080;
`

const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const Text = styled.span`
    font-family: SF Pro Display;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0;
    color: #000000;
`;

const CountriesTooltipBox = styled.div`
  display: none;
  position: absolute;
  bottom: 20px;
  left: 0;
  width: 498px;
  background-color:#E2E5FF;
  border-radius: 15px;
  font-family: SF Pro Display;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0;
  padding: 17px 14px 15px 14px;
`;

const InfoGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const InfoBlockContent = styled.div`
    width: 100%;
    display: flex;
    gap: 87px;
`;

const InfoBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
  position: relative;

  &:hover ${CountriesTooltipBox} {
    display: block;
  }
`;

export default PlatformCountries;
